import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="239" height="239" viewBox="0 0 239 239" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M119.698 237.611C185.036 237.611 238.003 184.644 238.003 119.305C238.003 53.9671 185.036 1 119.698 1C54.3597 1 1.39258 53.9671 1.39258 119.305C1.39258 184.644 54.3597 237.611 119.698 237.611Z" stroke="white" strokeMiterlimit="10" strokeDasharray="5 5"/>
    </svg>
)
